export default "__VITE_ASSET__WBsnipuw__"